import styled from "styled-components"

type StyledProps = {
  $ignoreLargeScreen?: boolean
}

export const PeriodSelection = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.8rem;
`

export const SelectWrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.8rem;
  background-color: ${(p) => p.theme.colors.greyLighter};
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.75rem;
  margin-bottom: 1rem;

  ${(p) => (p.theme.mQ.MEDIA_MIN_X_LARGE)} {
    flex-direction: ${p => p.$ignoreLargeScreen ? "column" : "row"};
    align-items: ${p => p.$ignoreLargeScreen ? "flex-start" : "center"};
    width: auto;
  }
`

export const Layout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;

  ${(p) => p.theme.mQ.MEDIA_SMALL} {
    flex-direction: column;
  }

`

export const MultiSelectWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  `

export const LayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  align-items: stretch;

  ${(p) => p.theme.mQ.MEDIA_SMALL} {
    flex-direction: column;
  }
`

export const CampaignIconWrapper = styled.div`
  display: none;
  height: 100%;

  align-items: center;

  svg {
    height: 2.8rem;
    margin-right: 0.8rem;
    margin-left: 1.5rem;
  }

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    display: flex;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;
  z-index: 3;

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    grid-template-columns: 1fr 1fr
  }

  ${(p) => p.theme.mQ.MEDIA_MIN_X_LARGE} {
    grid-template-columns: 1fr 1fr 1fr 1fr
  }
`
